import { useState } from 'react'
import * as css from './styles'
import { AiThresholdSelector } from '../../ai-threshold-selector'
import { CreativeField } from '../creative-field'
import { t } from '@lingui/core/macro'

interface AiClassificationFieldProps {
  fieldName: string
  fieldThreshold?: number
  onChangeTreshold?: (value: number) => void
}

export const AiClassificationField = ({
  fieldName,
  fieldThreshold,
  onChangeTreshold,
}: AiClassificationFieldProps) => {
  const [treshold, setTreshold] = useState(fieldThreshold)

  return (
    <CreativeField>
      <css.Container>
        <div style={{ padding: 15, width: '25%' }}>
          <css.FieldLabel>{t`Field name`}</css.FieldLabel>
          <css.FieldName>{fieldName}</css.FieldName>
        </div>
        <div style={{ flex: 1, padding: 7 }}>
          <AiThresholdSelector
            title={t`Threshold`}
            onChangeCommitted={onChangeTreshold}
            onChange={setTreshold}
            value={treshold}
          />
        </div>
      </css.Container>
    </CreativeField>
  )
}
